var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.52 491.52",
    xmlSpace: "preserve",
    width: "40px",
    height: "40px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M487.813,168.546h-42.016c-2.047,0-3.706,1.7-3.706,3.798v85.595c0,2.097,1.659,3.799,3.706,3.799 h42.016c2.048,0,3.707-1.702,3.707-3.799v-85.595C491.52,170.246,489.861,168.546,487.813,168.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F4859"
    },
    d: "M428.64,305.188l-4.871-7.419l33.566-23.162c3.203-2.207,5.11-5.891,5.11-9.843v-22.569h8.722v22.569 c0,6.928-3.348,13.378-8.961,17.253L428.64,305.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M479.144,233.089h-24.673c-1.247,0-2.257,1.035-2.257,2.311v17.126c0,1.276,1.01,2.311,2.257,2.311 h24.673c1.246,0,2.255-1.035,2.255-2.311V235.4C481.398,234.124,480.389,233.089,479.144,233.089z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 457.574,
    cy: 237.824,
    rx: 2.186,
    ry: 2.243
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 457.574,
    cy: 250.081,
    rx: 2.186,
    ry: 2.243
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 476.006,
    cy: 237.824,
    rx: 2.186,
    ry: 2.243
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 476.006,
    cy: 250.081,
    rx: 2.186,
    ry: 2.243
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M3.706,168.546h42.017c2.046,0,3.704,1.7,3.704,3.798v85.595c0,2.097-1.658,3.799-3.704,3.799H3.706 c-2.048,0-3.706-1.702-3.706-3.799v-85.595C0,170.246,1.658,168.546,3.706,168.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F4859"
    },
    d: "M62.878,305.188l4.872-7.419l-33.566-23.162c-3.203-2.207-5.111-5.891-5.111-9.843v-22.569h-8.721 v22.569c0,6.928,3.348,13.378,8.96,17.253L62.878,305.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M12.376,233.089h24.673c1.247,0,2.256,1.035,2.256,2.311v17.126c0,1.276-1.009,2.311-2.256,2.311 H12.376c-1.246,0-2.255-1.035-2.255-2.311V235.4C10.121,234.124,11.131,233.089,12.376,233.089z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 33.93,
    cy: 237.824,
    rx: 2.191,
    ry: 2.243
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 33.93,
    cy: 250.081,
    rx: 2.191,
    ry: 2.243
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 15.514,
    cy: 237.824,
    rx: 2.186,
    ry: 2.243
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 15.514,
    cy: 250.081,
    rx: 2.186,
    ry: 2.243
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M58.737,33.098v378.811c0,5.941,4.699,10.757,10.498,10.757h353.049 c5.798,0,10.498-4.815,10.498-10.757l0.001-378.811C432.782-11.032,58.736-11.032,58.737,33.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F4859"
    },
    d: "M396.39,97.827H95.131c-3.602,0-6.522,2.991-6.522,6.682v165.863c0,3.69,2.92,6.682,6.522,6.682 h301.257c3.601,0,6.522-2.991,6.522-6.682l0.002-165.863C402.912,100.818,399.992,97.827,396.39,97.827z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.142,
    y: 106.573,
    style: {
      fill: "#27A2DB"
    },
    width: 297.216,
    height: 161.736
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2D93BA"
    },
    points: "97.144,268.308 394.379,106.571 394.374,268.308 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M335.915,24.9h-180.31c-7.169,0-12.98,5.955-12.98,13.301v27.623c0,7.346,5.811,13.3,12.98,13.3 h180.31c7.168,0,12.98-5.954,12.98-13.3V38.201C348.895,30.855,343.083,24.9,335.915,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M143.513,70.57c1.869,4.993,6.559,8.554,12.091,8.554h180.309c5.532,0,10.224-3.561,12.093-8.554 H143.513z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M169.199,43.843c-0.594,0.491-0.894,1.136-0.894,1.943c0,0.806,0.365,1.445,1.091,1.923 c0.73,0.475,2.408,1.039,5.038,1.684c2.631,0.649,4.673,1.62,6.125,2.915c1.456,1.296,2.182,3.189,2.182,5.674 c0,2.484-0.933,4.499-2.795,6.045c-1.866,1.548-4.319,2.32-7.359,2.32c-4.387,0-8.34-1.627-11.858-4.876l3.69-4.522 c2.988,2.617,5.751,3.928,8.287,3.928c1.136,0,2.031-0.245,2.68-0.736c0.645-0.488,0.971-1.149,0.971-1.982 c0-0.833-0.346-1.494-1.033-1.985c-0.687-0.487-2.049-0.984-4.084-1.485c-3.227-0.769-5.586-1.766-7.08-2.995 c-1.495-1.23-2.241-3.16-2.241-5.791c0-2.63,0.947-4.66,2.838-6.086c1.889-1.43,4.248-2.143,7.078-2.143 c1.849,0,3.702,0.316,5.551,0.953c1.853,0.635,3.463,1.533,4.838,2.698l-3.13,4.518c-2.408-1.824-4.893-2.733-7.455-2.733 C170.607,43.111,169.793,43.353,169.199,43.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M200.748,60.559c3.04,0,5.525-1.201,7.456-3.609l3.966,4.086c-3.146,3.544-6.854,5.312-11.124,5.312 c-4.27,0-7.784-1.346-10.548-4.044c-2.762-2.698-4.144-6.099-4.144-10.211c0-4.111,1.408-7.543,4.222-10.292 c2.818-2.75,6.261-4.126,10.331-4.126c4.547,0,8.357,1.734,11.422,5.197l-3.846,4.36c-1.956-2.431-4.39-3.646-7.297-3.646 c-2.328,0-4.316,0.761-5.968,2.281c-1.653,1.521-2.478,3.567-2.478,6.146c0,2.579,0.781,4.648,2.339,6.206 C196.636,59.78,198.527,60.559,200.748,60.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M234.258,38.312h6.188v27.721h-6.188V55.126h-11.025v10.906h-6.188V38.312h6.188v11.58h11.025 V38.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M270.587,62.204c-2.802,2.737-6.252,4.106-10.35,4.106s-7.549-1.369-10.351-4.106 c-2.804-2.736-4.206-6.139-4.206-10.211c0-4.07,1.402-7.475,4.206-10.212c2.802-2.737,6.252-4.106,10.351-4.106 s7.549,1.369,10.35,4.106s4.206,6.142,4.206,10.212C274.793,56.065,273.389,59.468,270.587,62.204z M268.486,52.012 c0-2.472-0.793-4.58-2.379-6.326c-1.587-1.743-3.536-2.617-5.851-2.617c-2.315,0-4.264,0.875-5.848,2.617 c-1.587,1.746-2.382,3.854-2.382,6.326c0,2.472,0.794,4.576,2.382,6.306c1.584,1.734,3.534,2.598,5.848,2.598 c2.314,0,4.264-0.864,5.851-2.598C267.693,56.588,268.486,54.484,268.486,52.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M303.343,62.204c-2.802,2.737-6.252,4.106-10.351,4.106c-4.099,0-7.549-1.369-10.35-4.106 c-2.804-2.736-4.206-6.139-4.206-10.211c0-4.07,1.402-7.475,4.206-10.212c2.802-2.737,6.251-4.106,10.35-4.106 c4.099,0,7.549,1.369,10.351,4.106c2.802,2.737,4.205,6.142,4.205,10.212C307.549,56.065,306.145,59.468,303.343,62.204z M301.242,52.012c0-2.472-0.795-4.58-2.379-6.326c-1.588-1.743-3.537-2.617-5.851-2.617c-2.315,0-4.264,0.875-5.848,2.617 c-1.588,1.746-2.382,3.854-2.382,6.326c0,2.472,0.794,4.576,2.382,6.306c1.584,1.734,3.534,2.598,5.848,2.598 c2.314,0,4.262-0.864,5.851-2.598C300.447,56.588,301.242,54.484,301.242,52.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M312.783,66.033V38.312h6.188v22.207h11.819v5.513H312.783z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M300.01,299.127H191.508c-6.958,0-12.6,6.349-12.6,14.18v73.404c0,7.831,5.642,14.18,12.6,14.18 H300.01c6.959,0,12.6-6.348,12.6-14.18v-73.404C312.61,305.476,306.97,299.127,300.01,299.127z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.412,
    y: 314.368,
    style: {
      fill: "#FCD462"
    },
    width: 8.545,
    height: 71.296
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.708,
    y: 314.368,
    style: {
      fill: "#FCD462"
    },
    width: 8.545,
    height: 71.296
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.979,
    y: 314.368,
    style: {
      fill: "#FCD462"
    },
    width: 8.545,
    height: 71.296
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.97,
    y: 314.368,
    style: {
      fill: "#FCD462"
    },
    width: 8.545,
    height: 71.296
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.267,
    y: 314.368,
    style: {
      fill: "#FCD462"
    },
    width: 8.545,
    height: 71.296
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.563,
    y: 314.368,
    style: {
      fill: "#FCD462"
    },
    width: 8.545,
    height: 71.296
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 126.244,
    cy: 341.77,
    rx: 30.925,
    ry: 31.688
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EBF0F3"
    },
    cx: 126.244,
    cy: 341.77,
    rx: 24.525,
    ry: 25.129
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E6E9"
    },
    d: "M126.242,316.641c-0.584,0-1.154,0.048-1.729,0.09c11.683,0.478,21.062,10.294,21.062,22.38 c0,12.386-9.837,22.466-21.929,22.466c-11.791,0-21.37-9.611-21.837-21.577c-0.041,0.587-0.088,1.174-0.088,1.77 c0,13.852,11.001,25.126,24.519,25.126c13.523,0,24.525-11.274,24.525-25.126C150.767,327.914,139.764,316.641,126.242,316.641z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#D5D6DB"
    },
    cx: 126.244,
    cy: 341.77,
    rx: 5.98,
    ry: 6.129
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E56353"
    },
    cx: 98.304,
    cy: 387.84,
    rx: 9.702,
    ry: 9.943
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DC8744"
    },
    cx: 154.163,
    cy: 387.84,
    rx: 9.702,
    ry: 9.943
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2F4859"
    },
    cx: 365.261,
    cy: 341.77,
    rx: 30.925,
    ry: 31.688
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EBF0F3"
    },
    cx: 365.261,
    cy: 341.77,
    rx: 24.52,
    ry: 25.129
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E6E9"
    },
    d: "M365.28,316.641c-0.584,0-1.156,0.048-1.73,0.09c11.683,0.478,21.063,10.294,21.063,22.38 c0,12.386-9.837,22.466-21.929,22.466c-11.79,0-21.371-9.611-21.837-21.577c-0.041,0.587-0.088,1.174-0.088,1.77 c0,13.852,11.002,25.126,24.521,25.126c13.523,0,24.524-11.274,24.524-25.126C389.804,327.914,378.803,316.641,365.28,316.641z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#D5D6DB"
    },
    cx: 365.261,
    cy: 341.77,
    rx: 5.98,
    ry: 6.129
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E56353"
    },
    cx: 337.352,
    cy: 387.84,
    rx: 9.702,
    ry: 9.943
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DC8744"
    },
    cx: 393.216,
    cy: 387.84,
    rx: 9.702,
    ry: 9.943
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.807,
    y: 422.656,
    style: {
      fill: "#3A556A"
    },
    width: 58.854,
    height: 13.204
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M75.807,435.869v47.591c0,4.451,3.521,8.06,7.866,8.06h43.121c4.345,0,7.866-3.609,7.866-8.06 v-47.591H75.807z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.864,
    y: 422.656,
    style: {
      fill: "#3A556A"
    },
    width: 58.854,
    height: 13.204
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M356.86,435.869v47.591c0,4.451,3.521,8.06,7.865,8.06h43.122c4.344,0,7.865-3.609,7.865-8.06 v-47.591H356.86z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolBus);
export default __webpack_public_path__ + "static/media/school-bus.593a30fa67a7f7f523fb51ad733d2ee5.svg";
export { ForwardRef as ReactComponent };